export default {
  name: 'about-entry',

  props: {
    page: {
      type: String,
      required: true,
      default: 'location'
    },
    aboutData: {
      type: Object,
      require: true
    }
  },

  methods: {
    headerTitle() {
      switch (this.page) {
        case 'location': {
          return this.$t('rcsite.entrypages.comp5.about', { NAME: this.aboutData.title })
        }
        case 'rental': {
          return this.$t('entrypages.comp6.location.title', { NAME: `<strong class="text-rental">${this.aboutData.tagTitle}</strong>` })
        }
      }
    }
  }
}
